import Header from '@/components/Header';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface CompanyPageErrorStateProps {
  onRetry: () => void;
  onGoBack: () => void;
}

export function CompanyPageErrorState({ onRetry, onGoBack }: CompanyPageErrorStateProps) {
  return (
    <div className="bg-background min-h-screen pb-28">
      <Header showBack />

      <div className="container flex min-h-[calc(100vh-8rem)] items-center justify-center py-12">
        <div className="border-border bg-card w-full max-w-xl rounded-2xl border p-8 text-center shadow-sm">
          <AlertCircle className="text-destructive mx-auto mb-4 h-12 w-12" />
          <h1 className="text-card-foreground text-2xl font-bold">Não foi possível carregar este estabelecimento</h1>
          <p className="text-muted-foreground mt-2 text-sm">
            Verifique sua conexão e tente novamente. Se o problema continuar, volte para a lista e escolha outro
            estabelecimento.
          </p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <Button onClick={onRetry}>Tentar novamente</Button>
            <Button variant="outline" onClick={onGoBack}>
              Voltar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
